import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import RAGIndicator from "components/visuals/RAGIndicator";

import { selectors } from "modules/customer/insights/performance/sales/productCategoryBreakdown";

const CategoriesGrowingOrDeclining = () => {
    const categoriesGrowingOrDeclining = useSelector(state => selectors.categoriesGrowingOrDeclining(state));
    const { loading, error, id, label, status, value } = categoriesGrowingOrDeclining;

    return (
        <Box data-cy={id}>
            <RAGIndicator loading={loading} error={error} label={label} status={status} value={value} />
        </Box>
    );
};

export default CategoriesGrowingOrDeclining;
